import React, { useRef, useEffect } from 'react';
import { Toast } from 'primereact/toast';
import { ModalInstall } from './ModalInstall';
import { ModalUpdateUser } from './ModalUpdateUser';
import { Header } from './Header';

export const PostLoginWrapper = ({ children, error, isMain, isField, fieldId, isCreateField, stepIndex, prevStep, isNotifications, isLegalModalVisible, userCountry, dataActCountryObligatory }) => {
    const toast = useRef(null);
    useEffect(() => {
        if (error) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: error, life: 6000 });
        }
    }, [error]);

    return (
        <>
            <ModalInstall />
            <ModalUpdateUser />
            <div className="flex flex-column align-items-center w-full" style={{ height: '100vh', maxWidth: '1024px' }}>
                <div className="flex flex-column align-items-center w-full mobile-max-width">
                    <Toast ref={toast} position="top-center" className="w-11" />
                    <Header
                        isMain={isMain}
                        isNotifications={isNotifications}
                        isField={isField}
                        fieldId={fieldId}
                        isCreateField={isCreateField}
                        stepIndex={stepIndex}
                        prevStep={prevStep}
                        isLegalModalVisible={isLegalModalVisible}
                        userCountry={userCountry}
                        dataActCountryObligatory={dataActCountryObligatory}
                    />
                    {children}  {/* Aquí se renderiza el contenido adicional */}
                </div>
            </div>
        </>
    );
};
